import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CenteredBox from "../common/CenteredBox";
import { useEffect } from "react";
import { retryFetch } from "@caredna-marlin/utils/client";
import FHIR from "fhirclient";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/state/auth";
import { TokenResponse } from "@caredna-marlin/utils/auth";

export default function FHIRCallbackScreen() {
  const navigate = useNavigate();
  const { loggedIn } = useAuth();

  useEffect(() => {
    (async () => {
      const client = await FHIR.oauth2.ready();

      const { serverUrl, tokenResponse, tokenUri } = client.state
      const response = await retryFetch(() => fetch(
        import.meta.env.VITE_SERVICE_HOST + "/fhir/token-exchange",
        {
          method: "POST",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ serverUrl, tokenResponse, tokenUri }),
        }
      ), 1);
      const json = await response.json() as TokenResponse;
      const redirectURL = loggedIn(json);

      navigate(redirectURL, { replace: true })
    })();
  }, []);

  return (
    <CenteredBox>
      <HourglassBottomIcon fontSize="large" sx={{ textAlign: "center" }} />
    </CenteredBox>
  );
}
